import { PropsWithChildren } from 'react';

import { clientModules } from '@/clientModules';

export default function XApiProvider({ children }: PropsWithChildren) {
  return clientModules.xAPIEvents.XApiProvider ? (
    <clientModules.xAPIEvents.XApiProvider>{children}</clientModules.xAPIEvents.XApiProvider>
  ) : (
    children
  );
}
